// extracted by mini-css-extract-plugin
module.exports = {"portal":"styles__portal__3oZb0","wrapper":"styles__wrapper__2iNqJ","btn-close":"styles__btn-close__3C5kL","btnClose":"styles__btn-close__3C5kL"};